import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { encryptedStorage } from 'src/utils/storage'

type GoBackStore = {
  goBackState: boolean
  resetGoBackState: () => void
  setGoBackState: (state: boolean) => void
}

export const useGoBackStore = create<GoBackStore>()(
  persist(
    (set) => ({
      goBackState: true,
      resetGoBackState: () => set(() => ({ goBackState: true })),
      setGoBackState: (state: boolean) => set(() => ({ goBackState: state })),
    }),
    {
      name: 'go-back-storage',
      storage: encryptedStorage(),
    }
  )
)
